import Vue from 'vue'
import VueRouter from 'vue-router'
import Cookies from 'js-cookie'
import GlobalData from '@/api/global_data'

Vue.use(VueRouter)

const globalRoutes = GlobalData.getGlobalRoutes()

const router = new VueRouter({
  routes: [
    {
      path: '/login',
      name: '登录',
      component: () => import('@/modules/home/Login')
    },
    {
      path: '/',
      name: '主页',
      component: () => import('@/modules/home/MainFrame'),
      children: globalRoutes
    },
    {
      path: '/404',
      name: '未发现',
      component: () => import('@/modules/home/404'),
      meta: {
        notNeedLogin: true // 不需要鉴权
      }
    }
  ]
})
router.beforeEach((to, from, next) => {
  // 登录界面登录成功之后，会把用户信息保存在会话
  // 存在时间为会话生命周期，页面关闭即失效。
  const token = Cookies.get('sid')
  if (to.path === '/login') {
    // 如果是访问登录界面，如果用户会话信息存在，代表已登录过，跳转到主页
    if (token) {
      next({ path: '/' })
    } else {
      document.title = to.name + ' E-Path'
      next()
    }
  } else {
    if (!token) {
      // console.log(from, '->', to)
      // 如果访问非登录界面，且户会话信息不存在，代表未登录，则跳转到登录界面
      if (from.name !== '登录') next({ path: '/login' })
    } else {
      // 加载动态菜单和路由
      // console.log(from, '->', to)
      document.title = to.name + ' E-Path'
      next()
      // next({ path: "/" });
    }
  }
})
export default router
